export default function TopBar() {
    return (
        <div data-testid="topbar" className="bg-[#050D08] text-[#7A9088] text-[12.5px] py-2 border-b border-[#1F3A2B]">
            <div className="max-w-[1180px] mx-auto px-8 flex items-center justify-between gap-4">
                <div className="flex items-center gap-6 min-w-0">
                    <span className="whitespace-nowrap text-[#B8CFC0]"><i className="fa-solid fa-phone text-[#DFFF3D] mr-1.5" />+1 (610) 445-0243</span>
                    <span className="hidden sm:inline whitespace-nowrap text-[#B8CFC0]"><i className="fa-solid fa-envelope text-[#DFFF3D] mr-1.5" />info@vusolutions-dev.com</span>
                    <span className="hidden md:inline whitespace-nowrap"><i className="fa-solid fa-clock text-[#DFFF3D] mr-1.5" />Mon–Fri, 9am–6pm ET</span>
                </div>
                <div className="flex gap-2.5 shrink-0">
                    {["facebook-f", "instagram", "linkedin-in"].map((s) => (
                        <a key={s} href={s === "facebook-f" ? "https://www.facebook.com/vusolutionsdev/" : "#"} target="_blank" rel="noopener noreferrer" className="w-[26px] h-[26px] rounded-full border border-[#1F3A2B] flex items-center justify-center text-[11px] hover:bg-[#DFFF3D] hover:border-[#DFFF3D] hover:text-[#0E1F16] transition-colors">
                            <i className={`fa-brands fa-${s}`} />
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}
